// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky_buttons[data-v-47b8afa7]{position:sticky;top:135px;z-index:999;height:70px;background-color:#fff}.btn_bottom_width[data-v-47b8afa7]{width:270px}", ""]);
// Exports
module.exports = exports;
